import { TInitialState } from '~/src/features/tariffBuilder/reducer';

/**
 * Возвращает true если на адресе ограничена скорость интернета
 */
const isSpeedRestrictionByEqual100 = (state: TInitialState) => {
    return state.speedRestrictions !== undefined && state.speedRestrictions.min === 100 && state.speedRestrictions.max === 100;
};

export default isSpeedRestrictionByEqual100;
